import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { getUser, isAuthenticated } from "@/services/userLogin";

export function RequireAdmin({ children }: { children: ReactNode }) {
  if (!isAuthenticated()) return <Navigate to="/" replace />;

  const user = getUser();
  if (user?.role !== "admin") {
    return <Navigate to="/metrics/utilisation-rate" replace />;
  }

  return <>{children}</>;
}
